import { ISvgIconProps, } from '@Assets/icons/interface';
import { SvgIcon, } from '@Assets/icons/SvgIcon';
import React from 'react';

export const MinusIcon = (props: ISvgIconProps) => {
  return <SvgIcon {...props}>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </SvgIcon>;
};
